import React from 'react';
import { CSS } from '@dnd-kit/utilities';
import { DraggableAttributes } from '@dnd-kit/core';
import { SyntheticListenerMap } from '@dnd-kit/core/dist/hooks/utilities';
import type { Transform } from '@dnd-kit/utilities';
import './DashboardValueWithoutProgressKpiCard.scss';
import KPINumber from 'src/components/ui/KPINumber/KPINumber';
import CardContainer from '../../layouts/CardContainer/CardContainer';
import { DashboardValueWithoutProgressKpi } from '../../../services/kpi';

export interface DashboardValueWithoutProgressKpiCardProps {
  attributes?: DraggableAttributes;
  listeners?: SyntheticListenerMap;
  setNodeRef?: (node: HTMLElement | null) => void;
  transform?: Transform | null;
  transition?: string;
  data: DashboardValueWithoutProgressKpi[];
}

const DashboardValueWithoutProgressKpiCard: React.FC<DashboardValueWithoutProgressKpiCardProps> = ({
  attributes,
  listeners,
  setNodeRef,
  transform,
  transition,
  data,
}) => {
  const style = {
    transform: CSS.Transform.toString(transform || null),
    transition,
    touchAction: 'none',
  };

  return (
    <CardContainer
      className="returnsAndReasonsCard surface-elevated"
      ref={setNodeRef}
      style={style}
      attributes={attributes}
      listeners={listeners}>
      <div className="kpi-grid">
        {data.map(kpi => (
          <div className="kpi-cell" key={`${kpi.title}-${kpi.value}`}>
            <span className="kpi-title">{kpi.title}</span>
            <div className="kpi-number-wrapper">
              <KPINumber value={kpi.value?.toString()} />
            </div>
          </div>
        ))}
      </div>
    </CardContainer>
  );
};

export default DashboardValueWithoutProgressKpiCard;
